import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { Description } from '../description/description.js';
import { useIdProvider, getDescriptionId } from '../hooks/id-provider.js';
import { ManuallyLabeledCheckbox } from './manually-labeled-checkbox.js';
import { description, root } from './checkbox.css.js';

/**
 * Used for binary choices, like settings in our design editor, as well as for selecting individual rows in our admin interface.
 * @see https://fpl.figma.design/components/inputs/checkbox/
 */
const Checkbox = forwardRef(({ id: idIn, label, className, children, ...props }, ref) => {
    const hasDescription = !!children;
    const [id, Provider] = useIdProvider(idIn);
    const descriptionId = hasDescription ? getDescriptionId(id) : undefined;
    return (jsx(Provider, { value: id, children: jsxs("div", { className: clsx(root, className), children: [jsx(ManuallyLabeledCheckbox, { ...props, id: id, ref: ref, "aria-describedby": descriptionId }), label, hasDescription && jsx(Description, { className: description, children: children })] }) }));
});
Checkbox.displayName = 'Checkbox';

export { Checkbox };
//# sourceMappingURL=checkbox.js.map
